import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

const CopyAllButton = ({ data, userSettings = {} }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyAll = () => {
    // Check if we're using SOAP format
    const isSoapFormat = data.format === 'soap' || Boolean(data.subjective);
    
    // Create ordered sections based on format
    const sections = [];
    
    if (isSoapFormat) {
      // SOAP format sections
      sections.push({
        key: 'subjective',
        title: 'Subjective',
        value: data.subjective
      });
      
      sections.push({
        key: 'objective',
        title: 'Objective',
        value: data.objective
      });
      
      sections.push({
        key: 'assessment',
        title: 'Assessment',
        value: data.assessment
      });
      
      sections.push({
        key: 'plan',
        title: 'Plan',
        value: data.plan
      });
    } else {
      // Standard format sections
      // Always include HPI
      sections.push({
        key: 'hpi',
        title: 'History of Present Illness',
        value: data.hpi
      });
      
      // Include ROS if enabled
      if (userSettings.showROS !== false) {
        sections.push({
          key: 'ros',
          title: 'Review of Symptoms',
          value: data.ros
        });
      }
      
      // Include physical exam if enabled and has content
      if (userSettings.showPhysicalExam !== false && data.physical_exam && data.physical_exam.length > 0) {
        sections.push({
          key: 'physical_exam',
          title: 'Physical Exam',
          value: data.physical_exam
        });
      }
      
      // Always include Assessment & Plan
      sections.push({
        key: 'assessment_plan',
        title: 'Assessment & Plan',
        value: data.assessment_plan
      });
    }

    // Filter out sections with no content and format the text
    const formattedText = sections
      .filter(section => section.value && (
        Array.isArray(section.value) ? section.value.length > 0 : section.value.trim() !== ''
      ))
      .map(section => {
        const sectionContent = Array.isArray(section.value) ? section.value.join('\n') : section.value;
        // Remove markdown formatting for copying
        const cleanContent = sectionContent.replace(/\*\*(.*?)\*\*/g, '$1');
        return `${section.title}:\n${cleanContent}\n`;
      })
      .join('\n');

    navigator.clipboard.writeText(formattedText)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <button
      onClick={handleCopyAll}
      className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 rounded-md hover:bg-gray-50 transition-colors"
    >
      {copied ? (
        <>
          <Check className="w-4 h-4 text-green-500" />
          <span className="text-green-500">Copied!</span>
        </>
      ) : (
        <>
          <Copy className="w-4 h-4" />
          <span>Copy All</span>
        </>
      )}
    </button>
  );
};

export default CopyAllButton;